import { m8API } from 'services/production/m8';
import { SetClientPartnerBindingService } from 'types/services';

export const setClientPartnerBinding: SetClientPartnerBindingService = async (
  params
) => {
  const { clientId, partnerId } = params;

  await m8API.admin.setUserPartner({ idPartner: partnerId, idUser: clientId });
};
